webpackJsonp([70144966829960],{

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var to = _ref.to,
	      props = _objectWithoutProperties(_ref, ['to']);
	
	  var isExternalLink = false;
	  if (/^https?:\/\/.*/.test(to)) {
	    isExternalLink = true;
	  }
	
	  return isExternalLink ? Glamor.createElement('a', _extends({ href: to }, props)) : Glamor.createElement(_gatsbyLink2.default, _extends({ to: to }, props));
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _link = __webpack_require__(11);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _gmailIcon = __webpack_require__(137);
	
	var _githubIcon = __webpack_require__(136);
	
	var _linkedinIcon = __webpack_require__(138);
	
	var _twitterIcon = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        margin: '0 auto',
	        maxWidth: '960px',
	        padding: '0 2rem'
	      }
	    },
	    Glamor.createElement(_reactHelmet2.default, {
	      title: '\uD83D\uDCEC Contact - Emmanuel Fallancy',
	      meta: [{ name: 'description', content: 'Get in touch with Emmanuel' }, {
	        name: 'keywords',
	        content: 'efallancy, Emmanuel Fallancy, emmanuel fallancy'
	      }]
	    }),
	    Glamor.createElement(
	      'header',
	      {
	        css: {
	          padding: '0 1rem',
	          textAlign: 'center',
	          margin: '0 auto',
	          maxWidth: '300px'
	        }
	      },
	      Glamor.createElement(
	        'h1',
	        {
	          css: {
	            position: 'relative',
	            padding: '1rem 0',
	            '&::before': {
	              content: '""',
	              backgroundColor: 'rgba(37, 206, 209, 0.65)',
	              position: 'absolute',
	              top: '0',
	              left: '0',
	              transform: 'skew(-20deg)',
	              width: '100%',
	              height: '100%',
	              zIndex: '-1'
	            }
	          }
	        },
	        'Reach out'
	      )
	    ),
	    Glamor.createElement(
	      'main',
	      {
	        css: {
	          margin: '0 auto',
	          maxWidth: '480px'
	        }
	      },
	      Glamor.createElement(
	        'p',
	        {
	          css: {
	            fontSize: '1.8rem',
	            textAlign: 'center'
	          }
	        },
	        'Holla! Feel free to reach out to me.'
	      ),
	      Glamor.createElement(
	        'div',
	        {
	          css: {
	            alignItems: 'center',
	            display: 'flex',
	            justifyContent: 'center',
	            margin: '4rem 0 1rem',
	            width: '100%'
	          }
	        },
	        Glamor.createElement(
	          'a',
	          { href: 'mailto:emmanuel.fallancy@gmail.com?subject=Hi, Emmanuel!' },
	          Glamor.createElement(_gmailIcon.ReactComponent, {
	            height: '50px',
	            width: '70px',
	            css: {
	              marginRight: '2rem',
	              '@media(max-width: 355px)': {
	                marginRight: '1rem'
	              }
	            }
	          })
	        ),
	        Glamor.createElement(
	          _link2.default,
	          { to: 'https://github.com/emmafallancy' },
	          Glamor.createElement(_githubIcon.ReactComponent, {
	            height: '50px',
	            width: '50px',
	            css: {
	              marginRight: '2rem',
	              '@media(max-width: 355px)': {
	                marginRight: '1rem'
	              }
	            }
	          })
	        ),
	        Glamor.createElement(
	          _link2.default,
	          { to: 'https://www.linkedin.com/in/emmanuelfallancy' },
	          Glamor.createElement(_linkedinIcon.ReactComponent, {
	            height: '50px',
	            width: '50px',
	            css: {
	              marginRight: '2rem',
	              '@media(max-width: 355px)': {
	                marginRight: '1rem'
	              }
	            }
	          })
	        ),
	        Glamor.createElement(
	          _link2.default,
	          { to: 'https://twitter.com/fancyfallancy' },
	          Glamor.createElement(_twitterIcon.ReactComponent, {
	            height: '50px',
	            width: '60px',
	            css: {
	              marginRight: '2rem',
	              '@media(max-width: 355px)': {
	                marginRight: '1rem'
	              }
	            }
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M25 0C11.195 0 0 11.461 0 25.6c0 11.311 7.163 20.907 17.097 24.292 1.25.237 1.708-.555 1.708-1.231 0-.61-.023-2.627-.034-4.767-6.955 1.549-8.423-3.02-8.423-3.02-1.137-2.96-2.776-3.746-2.776-3.746-2.268-1.589.171-1.556.171-1.556 2.51.18 3.833 2.638 3.833 2.638 2.23 3.914 5.848 2.782 7.275 2.128.224-1.654.872-2.784 1.587-3.423-5.553-.647-11.39-2.843-11.39-12.652 0-2.795.976-5.079 2.576-6.871-.26-.645-1.116-3.249.242-6.775 0 0 2.1-.688 6.877 2.624 1.994-.567 4.133-.852 6.257-.861 2.125.01 4.265.294 6.263.861 4.772-3.312 6.868-2.624 6.868-2.624 1.361 3.526.505 6.13.245 6.775 1.603 1.792 2.573 4.076 2.573 6.871 0 9.833-5.848 11.998-11.415 12.632.897.794 1.696 2.352 1.696 4.74 0 3.426-.03 6.182-.03 7.026 0 .68.45 1.48 1.718 1.228C42.846 46.499 50 36.907 50 25.6 50 11.461 38.807 0 25 0zM9.363 36.468c-.055.127-.25.165-.428.078-.181-.083-.283-.257-.224-.384.053-.131.25-.168.43-.08.182.083.285.258.222.386zm1.23 1.124c-.12.113-.352.06-.51-.119-.164-.178-.194-.417-.074-.532.123-.113.35-.06.513.119.164.18.196.417.071.532zm.844 1.437c-.153.11-.404.007-.559-.22-.153-.228-.153-.501.004-.61.155-.11.402-.012.558.214.153.232.153.505-.003.616zm1.427 1.665c-.137.155-.43.113-.643-.098-.219-.206-.28-.5-.142-.654.139-.155.432-.111.648.098.216.206.283.501.137.654zm1.844.562c-.06.2-.342.292-.625.207-.283-.088-.468-.323-.41-.525.058-.202.34-.297.625-.206.283.087.468.32.41.524zm2.098.239c.007.21-.233.386-.53.39-.3.007-.541-.164-.544-.372 0-.213.234-.387.533-.392.298-.006.541.164.541.374zm2.062-.081c.035.206-.171.417-.467.474-.29.054-.558-.073-.595-.277-.036-.212.174-.423.464-.478.295-.052.56.071.598.28z",
	  fill: "#161614",
	  fillRule: "nonzero"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("defs", null, _react2.default.createElement("linearGradient", {
	  x1: ".004%",
	  y1: "49.998%",
	  x2: "100.032%",
	  y2: "49.998%",
	  id: "a"
	}, _react2.default.createElement("stop", {
	  stopOpacity: 0.1,
	  offset: "0%"
	}), _react2.default.createElement("stop", {
	  stopOpacity: 0.2,
	  offset: "100%"
	})));
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fillRule: "nonzero",
	  fill: "none"
	}, _react2.default.createElement("path", {
	  d: "M65.306 49.896H4.417c-2.36 0-4.349-1.816-4.349-4.1V4.334c0-2.226 1.926-4.1 4.35-4.1h60.888c2.361 0 4.35 1.816 4.35 4.1v41.462c0 2.284-1.927 4.1-4.35 4.1z",
	  fill: "#E3E3E3"
	}), _react2.default.createElement("path", {
	  fill: "#231F20",
	  opacity: 0.1,
	  d: "M8.766 49.896L34.8 30.16l.186-1.054-26.84-18.213-.063 38.124z"
	}), _react2.default.createElement("path", {
	  d: "M4.417 49.896c-2.423 0-4.349-1.816-4.349-4.1V4.276c0-2.285 1.926-2.695 4.35-2.695 2.422 0 4.348.469 4.348 2.694v45.62H4.417z",
	  fill: "#D54B3D"
	}), _react2.default.createElement("path", {
	  d: "M4.417 2.167c3.107 0 3.728.878 3.728 2.108V49.31H4.417c-2.05 0-3.728-1.581-3.728-3.514V4.276c0-1.29.622-2.11 3.728-2.11zm0-.586c-2.423 0-4.349.469-4.349 2.694v41.521c0 2.284 1.926 4.1 4.35 4.1h4.348V4.276c0-2.285-1.926-2.695-4.349-2.695z",
	  fill: "#D72B27"
	}), _react2.default.createElement("path", {
	  d: "M65.306 49.896h-4.35V4.158c0-2.284 1.927-2.577 4.35-2.577 2.423 0 4.35.293 4.35 2.577v41.697c0 2.225-1.927 4.04-4.35 4.04z",
	  fill: "#D54B3D"
	}), _react2.default.createElement("path", {
	  d: "M65.306 2.167c2.796 0 3.728.527 3.728 1.991v41.697c0 1.932-1.678 3.514-3.728 3.514h-3.728V4.158c0-1.523.932-1.991 3.728-1.991zm0-.586c-2.423 0-4.35.293-4.35 2.577v45.796h4.35c2.423 0 4.35-1.815 4.35-4.1V4.159c0-2.284-1.927-2.577-4.35-2.577z",
	  fill: "#D72B27"
	}), _react2.default.createElement("path", {
	  d: "M46.667 49.896L.432 5.978l2.432.932 32.184 21.844L69.655 4.835v41.02c0 2.225-1.926 4.04-4.349 4.04h-18.64z",
	  fill: "url(#a)"
	}), _react2.default.createElement("path", {
	  d: "M34.8 30.16L1.932 7.672C.006 6.325-.553 3.748.876 1.932 2.305.118 5.1-.292 7.089 1.055l27.773 19.033L62.82.82c1.926-1.347 4.66-.937 6.089.937 1.429 1.815.994 4.392-.994 5.74L34.8 30.16z",
	  fill: "#D54B3D"
	}), _react2.default.createElement("path", {
	  d: "M65.306.586c1.18 0 2.299.527 3.045 1.464 1.18 1.58.807 3.748-.808 4.919L34.8 29.457 2.305 7.203C.627 6.032.192 3.807 1.373 2.284 2.056 1.406 3.237.82 4.479.82c.808 0 1.616.234 2.237.703l27.71 18.974.374.234.372-.234L63.07 1.23c.684-.41 1.43-.644 2.237-.644zm0-.586c-.87 0-1.802.234-2.547.761L34.799 20.03 7.028.996C6.28.469 5.349.234 4.417.234 3.05.234 1.683.82.814 1.933-.553 3.748.006 6.325 1.932 7.672L34.8 30.218 67.854 7.496c1.926-1.347 2.36-3.865.994-5.74C67.978.587 66.673 0 65.306 0z",
	  fill: "#D72B27"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: "1em",
	    height: "1em"
	  }, props), _ref, _ref2);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fillRule: "nonzero",
	  fill: "none"
	}, _react2.default.createElement("path", {
	  d: "M46.093 0H3.948C1.934 0 .298 1.609.298 3.592V46.24c0 1.985 1.636 3.596 3.65 3.596h42.145c2.017 0 3.661-1.61 3.661-3.596V3.592C49.754 1.609 48.11 0 46.093 0",
	  fill: "#006087"
	}), _react2.default.createElement("path", {
	  d: "M11.299 6.861c2.346 0 4.251 1.92 4.251 4.285 0 2.366-1.905 4.287-4.251 4.287-2.35 0-4.254-1.921-4.254-4.287 0-2.364 1.903-4.285 4.254-4.285zM7.63 18.684h7.335v23.783H7.63V18.684zM19.566 18.684h7.037v3.25h.097c.98-1.87 3.372-3.842 6.94-3.842 7.429 0 8.8 4.926 8.8 11.33v13.045h-7.33V30.901c0-2.759-.05-6.306-3.812-6.306-3.817 0-4.402 3.004-4.402 6.107v11.765h-7.33V18.684",
	  fill: "#FFF"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M60 6.089c-2.208.999-4.58 1.674-7.07 1.978a12.56 12.56 0 0 0 5.412-6.951 24.351 24.351 0 0 1-7.816 3.049C48.28 1.723 45.08.197 41.54.197c-6.798 0-12.31 5.625-12.31 12.564 0 .985.11 1.944.32 2.864C19.318 15.1 10.247 10.098 4.176 2.497A12.705 12.705 0 0 0 2.51 8.813c0 4.36 2.174 8.206 5.477 10.459A12.072 12.072 0 0 1 2.41 17.7l-.001.158c0 6.088 4.243 11.167 9.874 12.32a12.091 12.091 0 0 1-5.559.216c1.567 4.992 6.113 8.625 11.5 8.726C14.01 42.49 8.703 44.5 2.935 44.5c-.993 0-1.973-.06-2.936-.176 5.448 3.565 11.918 5.645 18.87 5.645 22.642 0 35.023-19.146 35.023-35.75 0-.544-.012-1.086-.035-1.625A25.313 25.313 0 0 0 60 6.089",
	  fill: "#55ACEE",
	  fillRule: "nonzero"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-1483419db540022ab890.js